// 배포 버전 정보 — 푸터에 표시됨.
// 배포(빌드)할 때마다 CHANGELOG 버전과 함께 이 두 값을 갱신할 것.
export const APP_VERSION = "1.5.0";
export const DEPLOY_DATE = "2026-06-27";
